module.exports = __webpack_public_path__ + "img/forward.df35ded8.svg";